/**
 * Trạng thái của form
 */
export default {
  // Sự nghiệp thu
  BUSINESS: 1,
  // Loại thu
  REVENUE: 2,
  // Nội dung thu
  CONTENT_REVENUE: 3,
  // Lĩnh vực 
  FIELD: 4,
  // Nội dung chi
  CONTENT_EXPENSE: 5,
  // Tính chất
  OPERATION: 6,
  // Tính chất hoạt động
  OPERATION_EXPENSE: 7,

};
